/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "@app/app.component";
import { appConfig } from "@app/app.config";
import { environment } from "environments/environment";

Promise.all([
  fetch("/config/runtime-config.json")
    .then((response) => response.json())
    .then((config) => {
      if (environment.production) {
        environment.apiUrl = config.apiUrl;
        environment.xIbmClientId = config["x-ibm-client-id"];
      }
    }),
  fetch("/config/idpClientNonSecretDetails.json")
    .then((response) => response.json())
    .then((config) => {
      if (environment.production) {
        environment.clientId = config["clientId"];
        environment.scopes = config["scopes"];
        environment.openidConfiguration = config["openid-configuration"];
        environment.issuer = config["issuer"];
        environment.token_endpoint = config["token_endpoint"];
        environment.check_session_iframe = config["check_session_iframe"];
        environment.end_session_endpoint = config["end_session_endpoint"];
        environment.authorization_endpoint = config["authorization_endpoint"];
        environment.introspection_endpoint = config["introspection_endpoint"];
        environment.userinfo_endpoint = config["userinfo_endpoint"];
        environment.registration_endpoint = config["registration_endpoint"];
        environment.revocation_endpoint = config["revocation_endpoint"];
      }
    }),
]).then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
